import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service to manage multiple sidebars where we only want one open at a time.
 *
  Call it by setting up:
  readonly SIDEBAR_ID: string = 'sidebar-id';

  this.sidebarManager.activeSidebarChanged.subscribe((name) => {
    this.display = name == this.SIDEBAR_ID ? !this.display : false;
  });

  And to open/close call:
  open() {
    this.sidebarManager.setActiveSidebar(this.SIDEBAR_ID);
  }
 */
class SidebarManagerService {
    constructor() {
        /**
         * Subject that happens when a sidebar opens.
         */
        this.activeSidebarChanged = new Subject();
    }
    /**
     * Triggers an active sidebar event.
     */
    setActiveSidebar(item) {
        this.activeSidebarChanged.next(item);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SidebarManagerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SidebarManagerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SidebarManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SidebarManagerService };
